import firebase from 'firebase/compat/app';
import Timestamp = firebase.firestore.Timestamp;

export interface EmailParticle extends ParticleBase {
    attachments: [];
    bcc: string[];
    cc: string[];
    content: string;
    draftId?: string;
    emailAlias?: string;
    client?: string;
    clientEmailAddress: string;
    folders?: Map<string, string>; // changed?
    from: string;
    header?: string; // changed?
    id: string; // TODO: should be 'messageId' for clarity.
    snippet: string;
    threadId: string;
    to: string[];
    internalDate: Timestamp;
}

export interface ParticleBase {
    app: string;
    modified?: Timestamp;
    creationDate: Timestamp;
    particleDate: Timestamp;
    description?: string;
    content?: string;
    labelIds: string[];
    order?: number;
    position?: number;
    particleKey: string;
    particleType: string;
    status?: string;
    state?: string;
    temp: boolean;
    readStatus?: boolean;
    uid: string;
    subject: string;
}